import { EVERFLOW_OFFER_IDS } from '@/constants'
import type { User } from '~/types/auth'

export default (uid: number = EVERFLOW_OFFER_IDS.HOMEPAGE) => {
  const authStore = useAuthStore()
  const DEFAULT_OFFER_ID = 1
  const DEFAULT_AFFILIATE_ID = 1

  const script = document.createElement('script')
  script.src = 'https://www.tnjgfpa4sftrk.com/scripts/sdk/everflow.js'
  script.async = true

  script.onload = () => {
    const { saveBclickId } = useBclickId()

    // @ts-ignore - EF is a global from Everflow SDK
    const previousTransactionId = EF?.getTransactionId(EF?.urlParameter('oid') || DEFAULT_OFFER_ID)
    if (previousTransactionId) {
      authStore.updateUser({ ...authStore.getUser, everflowTransactionId: previousTransactionId } as User)
      return
    }

    // @ts-ignore - EF is a global from Everflow SDK
    const clickParams = {
      offer_id: EF?.urlParameter('oid') || DEFAULT_OFFER_ID,
      affiliate_id: EF?.urlParameter('affid') || DEFAULT_AFFILIATE_ID,
      sub1: EF?.urlParameter('sub1'),
      sub2: EF?.urlParameter('sub2'),
      sub3: EF?.urlParameter('sub3'),
      sub4: EF?.urlParameter('sub4'),
      sub5: EF?.urlParameter('sub5'),
      uid: EF?.urlParameter('uid') || uid,
      source_id: EF?.urlParameter('source_id'),
      transaction_id: EF?.urlParameter('_ef_transaction_id'),
    }

    // @ts-ignore - EF is a global from Everflow SDK
    EF.configure({
      tld: "insidersofdubai.com"
    });

    // @ts-ignore - EF is a global from Everflow SDK
    EF?.click(clickParams).then((transactionId: string) => {
      if (!transactionId) return

      // @ts-ignore - EF is a global from Everflow SDK
      const sub1 = EF?.urlParameter('sub1')
      if (sub1) {
        saveBclickId(sub1)
        if (!authStore.getUser?.bclickId) {
          authStore.updateUser({ ...authStore.getUser, bclickId: sub1, everflowTransactionId: transactionId } as User)
        } else {
          authStore.updateUser({ ...authStore.getUser, everflowTransactionId: transactionId } as User)
        }
      } else {
        authStore.updateUser({ ...authStore.getUser, everflowTransactionId: transactionId } as User)
      }
    }).catch((error: any) => {
      console.error('[EVERFLOW] Error during click registration:', error)
    })
  }

  script.onerror = () => {
    console.error('[EVERFLOW] Failed to load SDK')
  }

  document.head.appendChild(script)
}
